<div class="face-capture-step">

  <!-- ==================== ESTADO INICIAL (idle) ==================== -->
  <ng-container *ngIf="status === 'idle'">
    <p class="main-question">
      <strong>Captura tu rostro</strong>
    </p>
    <p class="subtext">
      Tomaremos una foto de tu rostro para verificar que coincida con tu documento de identidad.
    </p>

    <!-- Ejemplo de selfie -->
    <div class="example-wrapper">
      <div class="face-silhouette">
        <div class="oval-guide"></div>
      </div>
      <p class="example-label">Centra tu rostro en el óvalo</p>
    </div>

    <!-- Recomendaciones -->
    <div class="recommendation-box">
      <p class="title">Recomendaciones</p>
      <ul>
        <li>
          <span class="icon">&#10004;</span>
          Mira directamente a la cámara
        </li>
        <li>
          <span class="icon">&#10004;</span>
          Asegúrate de estar en un lugar bien iluminado
        </li>
        <li>
          <span class="icon">&#10004;</span>
          No uses lentes oscuros ni gorros
        </li>
        <li>
          <span class="icon">&#10004;</span>
          Mantén tu rostro descubierto
        </li>
      </ul>
    </div>

    <!-- Botón abrir cámara -->
    <button
      type="button"
      class="capture-button"
      (click)="openCameraModal($event)"
      [disabled]="loading"
    >
      Abrir cámara
    </button>

    <!-- Botón volver -->
    <div class="actions">
      <button type="button" class="back-btn" (click)="goBack()" [disabled]="loading">
        Volver
      </button>
    </div>
  </ng-container>

  <!-- ==================== PREVIEW DE SELFIE ==================== -->
  <ng-container *ngIf="status === 'preview'">
    <p class="main-question">
      <strong>Vista previa</strong>
    </p>
    <p class="subtext">
      Verifica que tu rostro se vea claramente antes de continuar.
    </p>

    <div class="preview">
      <div class="preview-wrapper">
        <div class="image-container selfie-preview">
          <img [src]="selfieImage" alt="Selfie capturada" />
        </div>
      </div>

      <div class="preview-controls">
        <button
          type="button"
          class="confirm-btn"
          (click)="confirmSelfie()"
          [disabled]="loading"
        >
          {{ loading ? 'Procesando...' : 'Confirmar' }}
        </button>
      </div>

      <button
        type="button"
        class="retake-btn"
        (click)="retakeSelfie()"
        [disabled]="loading"
      >
        Tomar otra foto
      </button>
    </div>
  </ng-container>

  <!-- ==================== ESTADO ANALIZANDO ==================== -->
  <ng-container *ngIf="status === 'analyzing'">
    <div class="analyzing-container">
      <div class="analyzing-spinner">
        <div class="spinner-ring"></div>
        <div class="face-icon">
          <mat-icon>face</mat-icon>
        </div>
      </div>
      <p class="analyzing-title">Analizando tu rostro...</p>
      <p class="analyzing-subtitle">Por favor espera, esto puede tomar unos segundos</p>
    </div>
  </ng-container>

  <!-- ==================== RESULTADO ÉXITO ==================== -->
  <ng-container *ngIf="status === 'success'">
    <div class="result-container success">
      <div class="result-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <p class="result-title">Verificación exitosa</p>
      <p class="result-subtitle">
        Tu identidad ha sido verificada correctamente.
      </p>
      <p class="auto-continue">Continuando automáticamente...</p>
    </div>
  </ng-container>

  <!-- ==================== RESULTADO ERROR ==================== -->
  <ng-container *ngIf="status === 'error'">
    <div class="result-container error">
      <div class="result-icon error">
        <mat-icon>error</mat-icon>
      </div>
      <p class="result-title">No pudimos verificar</p>
      <p class="result-subtitle">
        {{ verificationMessage }}
      </p>

      <!-- Agotados los intentos: se ofrece ayuda en lugar de dejar al usuario
           reintentando indefinidamente. -->
      <p class="result-subtitle" *ngIf="attemptsExhausted">
        Ya hiciste varios intentos. Escríbenos por WhatsApp y te ayudamos a completar la
        verificación.
      </p>

      <button
        type="button"
        class="continue-btn"
        *ngIf="attemptsExhausted"
        (click)="contactSupport()"
      >
        Contactar soporte por WhatsApp
      </button>

      <button
        type="button"
        class="retry-btn"
        (click)="retakeSelfie()"
      >
        Intentar de nuevo
      </button>

      <button
        type="button"
        class="back-btn-secondary"
        (click)="goBack()"
      >
        Volver al paso anterior
      </button>
    </div>
  </ng-container>

  <!-- ==================== MODAL DE CÁMARA ==================== -->
  <div class="camera-modal" *ngIf="showCameraModal">
    <div class="camera-wrapper">
      <p class="camera-guide-text">Centra tu rostro en el óvalo</p>

      <div class="camera-container">
        <video #video autoplay playsinline></video>

        <!-- Guía oval para rostro -->
        <div class="face-guide-overlay">
          <div class="oval-mask"></div>
        </div>
      </div>

      <div class="button-group">
        <button
          type="button"
          class="capture-button-overlay"
          (click)="captureSelfie()"
          [disabled]="!isReadyToCapture"
        >
          Capturar
        </button>
        <button
          type="button"
          class="close-button"
          (click)="closeCameraModal()"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>

</div>
